const onClickHandle = (e, eventName, eventInfo, link) => {
	e.preventDefault();

	if (window.eventDispatcher) {
		window.eventDispatcher.dispatchEventSync(eventName, eventInfo, {amplitude: true});
	}

	if (link) {
		window.location.href = link;
	}
};

export default onClickHandle;
